import { GameManager } from "../../GameManager";
import { ButtonWithText } from "../../utils/ButtonWithText";
import { GameTitle } from "./GameTitle";
import * as Carrom from "carrom-king-engine";
import { AudioManager } from "../../AudioManager";
import { BootScene } from "../BootScene";
declare global {
 
}
export class GameModeSelectionMenu extends Phaser.GameObjects.Container {
  private gameTitle: GameTitle;

  constructor(scene: Phaser.Scene) {
    super(scene);

    const gameText = this.scene.game.cache.json.get("game-text");

    this.gameTitle = new GameTitle(this.scene);
    this.add(this.gameTitle);
  
    const professionalButtonImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_big_orange");
    
         const professionalButtonText = new Phaser.GameObjects.Text(this.scene, 0, -5 + (BootScene.textYgap * -100), gameText.PROFESSIONAL, { fontFamily: "Teko-Medium", fontSize: "70px", color: "#FFFFFF" });
        
   professionalButtonText.setOrigin(.5,BootScene.originY);
    
    
    
    professionalButtonText.setShadow(0, 5, "#BA400E", 0, false, true);

    const professionalButton = new ButtonWithText(this.scene, professionalButtonImage, professionalButtonText, this.onClickProfessional, this);
    professionalButton.y = 15;
    this.add(professionalButton);

    const freestyleButtonImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_big_green");
    const freestyleButtonText = new Phaser.GameObjects.Text(this.scene, 0, -5 + BootScene.textYgap * -100, gameText.FREESTYLE, { fontFamily: "Teko-Medium", fontSize: "70px", color: "#FFFFFF" });
    freestyleButtonText.setOrigin(0.5,BootScene.originY);
    freestyleButtonText.setShadow(0, 5, "#1D8E11", 0, false, true);

    const freestyleButton = new ButtonWithText(this.scene, freestyleButtonImage, freestyleButtonText, this.onClickFreestyle, this);
    freestyleButton.y = 200;
    this.add(freestyleButton);

    const professionalDescription = new Phaser.GameObjects.Text(this.scene, 0, professionalButton.y + 76 + BootScene.textYgap * -55, gameText.PROFESSIONAL_MODE_DESCRIPTION, { fontFamily: "Wolf-Sans-Regular", fontSize: "25px", color: "#FFFFFF" });
    professionalDescription.setOrigin(0.5,BootScene.originY);
    professionalDescription.alpha = 0.5;
    this.add(professionalDescription);

    const freeStyleDescription = new Phaser.GameObjects.Text(this.scene, 0, freestyleButton.y + 76 + BootScene.textYgap * -55, gameText.FREESTYLE_MODE_DESCRIPTION, { fontFamily: "Wolf-Sans-Regular", fontSize: "25px", color: "#FFFFFF" });
    freeStyleDescription.setOrigin(0.5,BootScene.originY);
    freeStyleDescription.alpha = 0.5;
    this.add(freeStyleDescription);
  }

  public update(): void {
    this.gameTitle.update();
  }

  private onClickProfessional(): void {
    GameManager.onGameModeSelected(Carrom.GameMode.PROFESSIONAL);

    AudioManager.playSound("click_btn");
  }

  private onClickFreestyle(): void {
    GameManager.onGameModeSelected(Carrom.GameMode.FREESTYLE);

    AudioManager.playSound("click_btn");
  }
}
